<template>
  <div class="home-box">
    <div class="home" ref="homePage">
      <div class="home_content">
        <p class="content_text" ref="homePage1">{{$t("home.hometop")}}</p>
      </div>
    </div>
    <div class="home_wrap" ref="homePage2">
      <div class="home_videotitle" v-if="showPrise">
        <div class="home_videotitle_text">{{$t("home.homecenter")}}</div>
        <div class="home_videotitle_img" @click="home_videoBtn()"><img v-lazy="videoBtnimg" alt=""></div>
      </div>
      <div class="home_video" v-show="!showPrise">
        <!--<div style="width:100%;height:100%"></div>-->
        <video src="../../static/首页视频.mp4" width="100%" height="100%" id="video" controls controlslist="nodownload"></video>
        <div class="home_video_close" @click="videoClose()"><img v-lazy="videoCloseimg" alt=""></div>
      </div>
    </div>
    <!-- 暂时隐藏 -->
    <div v-show="false" class="home_Partners" ref="homePage3">
      <div class="home_Partners_box">
        <headerbar v-bind:message="$t(aboutMeg)"></headerbar>
        <div class="home_Partners_slideas">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(items,index) in imgArray" :key="index">
              <div class="slide_img" style="height:120px;"><img :src="items" alt=""></div>
            </swiper-slide>
          </swiper>
        </div>

      </div>
    </div>
    <!-- 合作伙伴暂时用这个 -->
    <div style="height:2px;overflow: hidden;background: #fff;">

    </div>
  </div>
</template>
<script>
import headerbar from "../components/common/header.vue"
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
export default {
  name: 'Home',
  data() {
    return {
      showPrise: true,
      clientHeight: '',
      videoBtnimg: require("../assets/images/Group4.png"),
      videoCloseimg: require("../assets/images/Group23.png"),
      aboutMeg: "home.homebottom",
      imgArray: [
        require("../assets/images/partnersc.png"),
        require("../assets/images/partnersd.png"),
        require("../assets/images/partnerse.png"),
        require("../assets/images/partnersf.png"),
        require("../assets/images/partnersg.png"),
        require("../assets/images/partnersl.png"),
        require("../assets/images/partnersq.png"),
        require("../assets/images/partnersr.png"),
        require("../assets/images/partnersk.png"),
        require("../assets/images/partnersn.png"),
        require("../assets/images/partnersp.png"),
        require("../assets/images/partnerst.png"),
        require("../assets/images/partnersu.png"),
        require("../assets/images/partnersv.png"),
        require("../assets/images/partnersw.png"),
        require("../assets/images/partnersy.png"),
        require("../assets/images/partnersz.png"),
         require("../assets/images/partnersb.png"),
        require("../assets/images/partnerss.png"),
        require("../assets/images/partnersx.png"),
        require("../assets/images/partnersm.png"),
        require("../assets/images/partnersa.png"),
      ],
      swiperOption: {
        pagination: '.swiper-pagination',
        autoplay: true,
        speed: 100,
        // loop: true,
        slidesPerView: 4,
        slidesPerGroup: 4,
        slidesPerColumn: 2,
      },
    }
  },
  components: { headerbar },
  created() {

  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
    this.changeFixed(this.clientHeight);
    // this.autoPlays()
    // this.showCurrent();
    // this.view()
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight)
    }
  },

  methods: {
    changeFixed(clientHeight) {                        //动态修改样式
      console.log(clientHeight);
      this.$refs.homePage.style.height = clientHeight - 80 + 'px';
      this.$refs.homePage1.style.lineHeight = clientHeight - 80 + 'px';
      this.$refs.homePage2.style.height = clientHeight - 80 + 'px';
      if (document.documentElement.clientWidth >= 1520) {
      this.$refs.homePage3.style.height = clientHeight - 280 + 'px';
      }
    },
    autoPlays() {
      var homeConten = document.getElementById('home_Partners_conten');
      setInterval(() => {
        if (homeConten.style.left <= 200) {
          // console.log(document.querySelectorAll("home_Partners_conten li:first-child"))
        } else {
          var step = 1;
          var left = parseInt(homeConten.style.left)
          homeConten.style.left = (left - step) + 'px'
          // console.log(left)
        }
      }, 10)

      homeConten.style.left = '-0';
    },
    //点击视频播放
    home_videoBtn() {
      this.showPrise = false
      var video = document.getElementById("video");
      video.play();
    },
    //关闭视频
    videoClose() {
      this.showPrise = true;
      var video = document.getElementById("video");
      video.load();
    },
  },
  created() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home_box {
  width: 100%;
  height: 100%;
    
  
}
video::-webkit-media-controls {
    overflow: hidden !important;
}
video::-webkit-media-controls-enclosure {
    width: calc(100% + 32px);
    /*margin-left: auto;*/
}
/*第一屏*/

@media screen and (max-width:1921px) {
  /*当屏幕尺寸小于1921px时，应用下面的CSS样式*/
  .home {
    width: 100%;
    height: 100%;
    background: url("../assets/images/Bitmap.png") no-repeat center center;
  }
}

@media screen and (min-width:1921px) {
  .home {
    width: 100%;
    height: 100%;
    background: url("../assets/images/Bitmap.png") no-repeat center center;
    background-color: #000;
  }
}

@media screen and (max-width:1300px) {
  .home_Partners_slideas {
    width: 1024px;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 60px;
  }
  .slide_img{
    height:100px;
  }
}

@media screen and (max-width:1301px) and (min-width:1565) {
  /*当屏幕尺寸小于1921px时，应用下面的CSS样式*/
  .home_Partners_conten {
    width: 70%;
    margin: 0px auto;
    margin-top: 50px;
    display: flex;
    margin-bottom: 100px;
  }
  .home_Partners_conten li {
    width: 200px;
    height: 72px;
    border: 1px solid #ccc;
    margin-left: 7px;
    text-align: center;
    line-height: 72px;
  }
  .home_Partners_slideas {
    width: 1024px;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 60px;
  }
  .slide_img{
    height:120px;
  }
}

@media screen and (min-width:1566px) and (max-width:1629px) {
  .home_Partners_conten {
    width: 70%;
    margin: 0px auto;
    margin-top: 200px;
    display: flex;
    margin-bottom: 100px;
  }

  .home_Partners_conten li {
    width: 200px;
    height: 72px;
    border: 1px solid #ccc;
    margin-left: 7px;
    text-align: center;
    line-height: 72px;
  }
  .home_Partners_slideas {
    width: 1024px;
    /*height: 320px;*/
    margin: 0 auto;
    margin-top: 120px;
  }
  .slide_img{
    height:120px;
  }
}

@media screen and (min-width:1630px) {
  .home_Partners_conten {
    width: 70%;
    margin: 0px auto;
    margin-top: 200px;
    display: flex;
    margin-bottom: 100px;
  }

  .home_Partners_conten li {
    width: 200px;
    height: 72px;
    border: 1px solid #ccc;
    margin-left: 7px;
    text-align: center;
    line-height: 72px;
  }
  .home_Partners_slideas {
    width: 1024px;
    margin: 0 auto;
    margin-top: 120px;
  }
  .slide_img{
    height:120px;
  }
}

@media screen and (min-width:1331px) and (max-width:1604px) {
  .home_Partners_conten {
    width: 70%;
    margin: 0px auto;
    margin-top: 200px;
    display: flex;
    margin-bottom: 100px;
  }

  .home_Partners_conten li {
    width: 200px;
    height: 72px;
    border: 1px solid #ccc;
    margin-left: 7px;
    text-align: center;
    line-height: 72px;
  }
  .home_Partners_slideas {
    width: 1024px;
    margin: 0 auto;
    margin-top: 120px;
  }
  .slide_img{
    height:120px;
  }
}

.home_content {
  width: 78%;
  margin: 0px auto;
}

.content_text {
  color: #fff;
  font-size: 52px;
  letter-spacing: 1px;
  text-align: center;
  font-weight: bold;
}

/*第二屏*/

.home_wrap {
  width: 100%;
  height: 100%;
  background: #000;
  background: url("../assets/images/Group.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
}

@media screen and (max-width:1921px) {
  /*当屏幕尺寸小于1921px时，应用下面的CSS样式*/
  .home_wrap {
    width: 100%;
    height: 100%;
    background: url("../assets/images/Group.png") no-repeat center center;
    position: relative;
  }
}

@media screen and (min-width:1921px) {
  .home_wrap {
    width: 100%;
    height: 100%;
    background: url("../assets/images/Group.png") no-repeat center center;
    background-color: #000;
    position: relative;
  }
}

.home_videotitle {
  /* width: 380px; */
  display: flex;
  margin: 0 auto;
  text-align: center;
  height: 36px;
  font-size: 36px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

}

.home_videotitle_img {
  margin-top: 5px;
  margin-left: 20px;
  cursor: pointer;
}

.home_video {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: #000;
  position: relative;
}

.home_video_close {
  position: absolute;
  top: 50px;
  left: 100px;
  cursor: pointer;
}

/*第三屏*/

.home_Partners {
  width: 100%;
  background: #fff;
  /* 暂时过度 */
  
}

.home_Partners_box {
  width: 78%;
  margin: 0px auto;
}

.title {
  width: 382px;
  height: 30px;
  font-size: 36px;
  margin: 0px auto;
  padding-top: 200px;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.title span {
  display: inline-block;
}

.title span:nth-child(2) {
  width: 40px;
  padding-bottom: 25px;
  text-align: center;
  border-bottom: 3px solid red;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue